import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/core/services/user.service';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';
import { AngularCsv } from 'angular7-csv/dist/Angular-csv'
import {PaginationInstance} from 'ngx-pagination';
import { Config } from 'src/app/config/constants';
import { saveAs } from 'file-saver';
@Component({
  selector: 'app-dashboard-mga',
  templateUrl: './dashboard-mga.component.html',
  styleUrls: ['./dashboard-mga.component.scss'],
  providers: [DatePipe],
})
export class DashboardMgaComponent implements OnInit {
   url: string ="https://www.getreliable.com/getreliable/login.aspx"
  set1: boolean = true;
  checkFlag1: boolean = false;
  selecteditem:boolean=false;
  subChecked: boolean = false;
  leadsList = [];
  selectedId = [];
  selectedDeactivatedId = [];
  showName: boolean = true;
  showLastName: boolean = true;
  showStage: boolean = true;
  showType: boolean = true;
  showPhone: boolean = true;
  showProvinces: boolean = true;
  showCity: boolean = true;
  showEmail: boolean=false;
  showLanguages: boolean=false;
  showStatus: boolean=false;
  showSource: boolean=false;
  showAddress: boolean=false;
  showPostal: boolean=false;
  showCountry: boolean=false;
  showSelling: boolean=false;
  showTitle: boolean=false;
  showCIPR: boolean = false;
  showLastTrainingDate: boolean = true;
  drop:boolean=false;
  noti:boolean=false;
  isMenuOpen = false;
  index: any;
  id :any;
  resetemail: any;
  leads=[];
  stage=[];
  total: any;
  filterModal:any;
  dropdownSettingsStage={}
  p: any=0;
  showExport: boolean=false;
  isDeactivateButton: boolean=false;
  showLead: any=30;
  onSelectSizePage: any=30;
  sub: any;
  uploadExpEOPopup: boolean=false;
  uploadnewLicensePopup:boolean=false; 
  currentDate:Date;
  currentDateabc:any;
  leadId: string;
  effectiveDate: string;
  MgaIddropdown: any;
  agentcodedata=[];
  agentcodedata1=[];
  mgaName: any;
  leadStatus: any;
  leadsId: any;
  subAgent:any;
  leadEmailAddress: any=[];
  error: any;
    primaryCompleteAddress:any;
  getPrimaryAddress: any=[];
  showAddressResults1: boolean=false;
  primaryAddressCity:any;
primaryAddressProvince:any;
primaryAddressPostalCode:any;
  salutation: any="";
  workPhoneExt: any;
  countTraining= 0;
  middleName: any;
  primaryAddressCountry= "Canada";
  userId: any;
  alternativeCompleteAddress: any;
  type: any="Broker";
  alternativeAddressCountry: any;
  languages: any=[];
  alternativeAddressCity: any;
  leadSource: any;
  ciprnumber: any;
  productSelling: any;
  positionTitle: any;
  alternativeAddressProvince: any;
  agencyMgaId: any;
  alternativeAddressPostalCode: any;
  mobileNumber: any;
  leadMailCompanian: any;
  emailAddress: any;
  leadSubSource: any;
  website: any;
  tags: any=[];
  allProvicesList: any=[];
  FirstSignUpDate: any;
  consentstat: any;
  proofConsent: any;
  adminOnly: any;
  ConsentDate: any;
  CountCalls: any=0;
  CountTasks: any=0;
  dncStatusval: any;
  agentNurture: any;
  ResidentLicenseExpiryDate: any;
  ResidentProvince: any;
  UserID: any;
  Password: any;
  TravelLink: any;
  RepresentingCompanies: any;
  OtherPhone: any;
  Fax: any;
  HomePhone: any;
  checkFlagCASLdata: boolean=false;
  Title: any;
  AgencyAdditionalOffices: any;
  residentAddressBeans: any=[];
  agencyCode: any;
  companyName: any;
  leadSourceOther: any;
  leadTraining: any;
  MyTravelLinkRequest: any;
  jumpStart: any;
  specialBonus: any;
  wfgCode: any;
  isCompanySignup: boolean=false
  commissionsTo="Broker";
  secondaryEmailAddress: any;
  agencyId: any;
  leadType: any;
  purchaseConfirmEmailFlag: boolean=false;
  ErrorMsgten: boolean=false;
  constructor(public user: UserService, public router: Router,private DatePipe:DatePipe,public config: Config) { }

  ngOnInit(): void {
    //debugger
    this.leadsId=sessionStorage.getItem('leadId');
    this.leadStatus=sessionStorage.getItem('leadStatus');
    this.getLeadAgentsCodes();
    this.MgaIddropdown=sessionStorage.getItem('MgaIddropdown');
    var filterState=localStorage.getItem('filterStatus');
    var filterIndex=localStorage.getItem('filterStatusIndex');
    var DocumentsTag=sessionStorage.getItem('selectedMgaIdDoc');
    var DocumentsTagCheck=sessionStorage.getItem('selectedMgaIdDocCheck');
    var DocumentsTagDeactivated=sessionStorage.getItem('selectedMgaIdDocDeactivated');
    if(filterState != undefined){
      this.test(filterState,filterIndex)
    }else{
      // this.getLeadListData();
      this.getMgaUnderLeads();
    }
    if(DocumentsTag=='true'|| DocumentsTagCheck=='true'){
      this.expdocumentsToggleAuto(true)
    }
    if(DocumentsTagDeactivated=='true'){
      this.deactivateddocumentsToggleAuto(true);
    }
    this.getFilterData();
    this.getLeadDoc();
    this.getDashboard();
    // this.moreInfoRequiredApi();
    this.dropdownSettingsStage = { 
      singleSelection: false, 
      text:"Select Stage",
      selectAllText:'Select All',
      unSelectAllText:'Unselect All',
      enableSearchFilter: true,
      classes:"myclass custom-class",
      badgeShowLimit: 2,
      labelKey: "itemName"

    };
    this.currentDate=new Date()
    this.currentDateabc =this.DatePipe.transform(this.currentDate, 'yyyy-MM-dd');
  }

  onItemSelectStage(item: any) {

  }
  OnItemDeSelectStage(item: any) {
  
  }
  onSelectAllStage(items: any) {

  }
  onDeSelectAllStage(items: any) {
  
  }
  selectAllCheckbox:boolean=false;
  toggleShow(data) {
    //debugger
    this.selectedId=[]
    this.selectedDeactivatedId=[]
    this.checkFlag1 = data.target.checked;
     //this.selecteditem = !this.selecteditem;
    if (this.checkFlag1 == true) {
      this.selecteditem = true;
      this.subChecked = true;
      this.selectallRecords=true;
      this.selectAllCheckbox=true;
      for(let i=0; i<this.leads.length;i++){
        if(this.leads[i].stageStatus == 'Sign-Up Complete' && this.leads[i].isDeactivatedByOfficeAdmin == false){
            this.selectedDeactivatedId.push(this.leads[i].id);
            this.isDeactivateButton=true;
        }
      }
      if(this.showActivatedTable==true){
        for(let i=0; i<this.leadsActivate.length;i++){
          this.leadsActivate[i].isChecked=true;
        }
        if(this.leadsActivate != null || undefined){
          for(let i=0; i<this.leadsActivate.length;i++){
            if(this.isDeactivate==true){
              this.selectedId.push(this.leadsActivate[i].id);
            }else{
              this.selectedId.push(this.leadsActivate[i].lead.id);
            }
            // console.log(this.selectedId)
          }
         }
      }else{
        for(let i=0; i<this.leads.length;i++){
          this.leads[i].isChecked=true;
        }
        if(this.leads != null || undefined){
          for(let i=0; i<this.leads.length;i++){
            this.selectedId.push(this.leads[i].id);
            // console.log(this.selectedId)
          }
         }
         if(this.selectedId.length>0){
          this.selectallRecords=true;
         }else{
          this.selectallRecords=false;
         }
      }
      this.showExport=true;
      
    }
    else {
      if(this.showActivatedTable==true){
        for(let i=0; i<this.leadsActivate.length;i++){
          this.leadsActivate[i].isChecked=false;
        }
      }else{
        for(let i=0; i<this.leads.length;i++){
          this.leads[i].isChecked=false;
        }
      }
      this.clearSelection=false;
      this.selectAllCheckbox=false;
      this.selecteditem = false;
      this.subChecked = false;
      this.selectedId=[];
      this.showExport=false;
      this.isDeactivateButton=false;
    }
  }
  counts: any=0;
  checkFlag2: boolean=false;
  selectedIdCheck: any;
  toggleShowSelected(data,id,index,item){
    //debugger
    // this.selectedDeactivatedId=[]
    this.selectAllCheckbox=false;
    this.checkFlag2 = data.target.checked;
     if (this.checkFlag2 == true) {
      // if (this.checkFlag1 == true) {
        // this.selecteditem = true;
        // this.subChecked = true;
        this.selectallRecords=true;
        this.selectedIdCheck=id;
        this.showExport=true;
        // this.isDeactivateButton=true;
        // this.selecteditem1 = true;
        this.selecteditem = false;
        this.counts++
        // for(let i=0; i<this.leads.length;i++){
          if(item.stageStatus == 'Sign-Up Complete' && item.isDeactivatedByOfficeAdmin == false){
              this.selectedDeactivatedId.push(id);
              this.isDeactivateButton=true;
          }
        // }
        if(this.showActivatedTable==true){
            if(this.isDeactivate==true){
              this.selectedId.push(this.leadsActivate[index].id);
            }else{
              if(this.selectedIdCheck==this.leadsActivate[index].id){
                this.selectedId.push(this.leadsActivate[index].lead.id);
              }
            }
            this.leadsActivate[index].isChecked=true;
        }else{
          this.selectedId.push(this.selectedIdCheck);
          this.leads[index].isChecked=true;
        }
      }
      else{
        this.selectedId.splice(index, 1);
        this.clearSelection=false;
        if(this.showActivatedTable==true){
          this.leadsActivate[index].isChecked=false;
        }else{
          this.leads[index].isChecked=false;
        }
        this.counts--
        if(this.counts== 0){
          this.selectallRecords=false;
          this.selectedId=[]
          this.showExport=false;
          this.isDeactivateButton=false;
          // this.selecteditem1=false;
        }else{
          this.selectallRecords=true;
        }
      }

  }

  notificationShow() {
    this.noti = !this.noti;
   if (this.noti) {
     this.noti = true;
     this.drop = false;
   }
   else {
     this.noti = false;
   }
  }
  toggleMenu() {
    // this.index=i;
     this.isMenuOpen = !this.isMenuOpen;
   }
   check(i){
  
    this.index=i;
 }
 toggleShowone(data) {
 
  for(let i = 0;i<this.leads.length ;i++)
  if(data == this.leads[i].id){
    for(let j=0; j<this.leads[i].leadEmail.length; j++){
      this.resetemail = this.leadsList[i].leadEmail[j].email;
 
    }
  }
  
  this.drop = !this.drop;
 if (this.drop== true) {
   this.drop = true;
   this.noti = false;
 }
 else {
   this.drop = false;
 }
}

getMgaUnderLeads() {
  //debugger
  this.user.getMGA(this.MgaIddropdown,this.leadPageNo,this.onSelectSizePage).pipe()
    .subscribe(
      data => {
        
        this.leads=[];
        this.stage=[];
        //
sessionStorage.removeItem("allMgaData")
        this.leads=data.data.leads;
        sessionStorage.setItem("allMgaData",JSON.stringify(data.data.leads))
        this.stage=data.data.stageWisePercentage;
        this.total=data.data.total;
        this.showLead=data.data.leads.length;
      }, error => {
        
      }, () => { });
}

commitionTypeArray=[];
leadTypesArray=[];
stagesArray=[];
fromDateTest: any;
brokerType: any;
commitionType: any;
stageStatusTest=[];
getFilterData() {
  this.user.getFilterData().pipe()
    .subscribe(
      data => {
        if(data.data != null || undefined){
        this.commitionTypeArray = data.data.commissiontypes;
        this.leadTypesArray = data.data.leadTypes;
       // this.stagesArray = data.data.stages;
       this.stagesArray=[];
        for(let i=0; i<data.data.stages.length; i++){
          this.stagesArray.push({"id":data.data.stages[i].name,"itemName":data.data.stages[i].displayName});
        }
        }
      },error=>{
      
          },()=>{});
}

stageStatus=[];
fromDate: any;
toDate: any;
fromDate1: any;
toDate1: any;



stageclrsignupcompleted: any;
stageclrbrokersignAgreement: any;
stageclrcompliancereview: any;
stageclrreviewinitialdoc: any;


showdate:boolean =false;
brokerTypeTest=[];
commitionTypeTest=[];
brokerType1=[];
commitionType1=[];
stageShow=[];
showFilter:boolean=false;
postFilter(){
  
  this.stageStatus=[];
  this.stageShow=[];
if(this.stageStatusTest != null || undefined){
for(let i=0; i<this.stageStatusTest.length; i++){
  this.stageStatus.push(this.stageStatusTest[i].id)
  this.stageShow.push(this.stageStatusTest[i].itemName)
  this.showFilter=true;
}

this.stageclrsignupcompleted=this.stageStatus.filter(itm=>itm=="ACTIVATED")
if(this.stageclrsignupcompleted.length>0){
}
this.stageclrbrokersignAgreement=this.stageStatus.filter(itm=>itm=="PENDING_BROKER_CONTRACT_SIGNING_TRAINING")
if(this.stageclrbrokersignAgreement.length>0){
  
}
this.stageclrcompliancereview=this.stageStatus.filter(itm=>itm=="REVIEW_INITIAL_DOCUMENT")
if(this.stageclrcompliancereview.length>0){
  
}
this.stageclrreviewinitialdoc=this.stageStatus.filter(itm=>itm=="LEADS_TRANSFERED_FROM_SUGAR")
if(this.stageclrreviewinitialdoc.length>0){
  
}
}
if(this.fromDateTest != null || undefined){
  this.fromDate=this.fromDateTest[0]
  this.fromDate = this.DatePipe.transform(this.fromDate, 'yyyy-MM-dd');

  this.toDate=this.fromDateTest[1]
  this.toDate = this.DatePipe.transform( this.toDate, 'yyyy-MM-dd');
}
else{
this.fromDate=null;
this.toDate=null;
}

if(this.brokerType == "Select"|| this.brokerType== undefined){
this.brokerType1=this.brokerTypeTest

}
else{
this.brokerType1.push(this.brokerType);
}
if(this.commitionType ==  "Select" || this.commitionType== undefined){
this.commitionType1=this.commitionTypeTest

}
else{
this.commitionType1.push(this.commitionType);
}
  this.fromDate1=this.fromDate
  this.fromDate1 = this.DatePipe.transform(this.fromDate1, 'MM-dd-yyyy');
  if(this.fromDateTest != null || undefined){
    this.showdate=true;
  }
  if(this.fromDate1 == null || undefined){
    this.showdate=false;
  }
  this.toDate1=this.toDate
  this.toDate1 = this.DatePipe.transform( this.toDate1, 'MM-dd-yyyy');


  this.user.filterLeadsPost(this.brokerType1,this.commitionType1,this.fromDate,this.stageStatus,this.toDate,this.MgaIddropdown)
  .pipe()
  .subscribe(
      data => {
        this.sub=100;
        if(data.status== true){   
          this.p=0
        // Swal.fire('',data.message,'success')
        this.filterModal =false;   
        }
        if(data.status== false){
          Swal.fire('',data.message,'error')
          this.filterModal =false;
          this.fromDateTest=null;
          this.toDate1=null;
          this.showdate=false;
          this.stageStatusTest=[];
          }
        if(data.data.leads.length != 0){
          this.leads=[];
          this.fromDateTest=null;
          this.stageStatusTest=[];
          for(let i=0; i<data.data.leads.length;i++){
            
            this.leads.push(data.data.leads[i]);
            this.total = data.data.total;
            this.showLead=data.data.total;
           
          }
          //
sessionStorage.removeItem("allMgaData")
          sessionStorage.setItem("allMgaData",JSON.stringify(data.data.leads))
        }
        if(data.data.stageWisePercentage.length != 0){
          this.stage=[];
          for(let i=0; i<data.data.stageWisePercentage.length;i++){
            this.stage.push(data.data.stageWisePercentage[i]);
           // this.total = data.data.totalPages
          }
        }

      },error=>{
        if(error=="Bad Request"){
          Swal.fire("Bad Request please try again!")
          this.filterModal=false;
         // this.onClearFilterData();
       }
       else{
        Swal.fire("Something went wrong. Please check and try again!")
        this.filterModal=false;
       // this.onClearFilterData();
       
       }
          },()=>{});
    this.onClearFilterData();
}
onClearFilterData(){
  if( this.brokerType != null || this.brokerType != undefined){
    // this.brokerType.clear();
    // this.brokerType=[];
    this.brokerType1=[];
  }
  if( this.commitionType != null || this.commitionType !=undefined){
    // this.commitionType.clear();
    // this.commitionType=[];
    this.commitionType1=[];
  }

   //this.stageStatusTest=[];
  // this.stageStatusTest=[];
}
onClickMga(event,id,mgaId){
  //debugger
  sessionStorage.setItem('selectedMgaId', id);
  sessionStorage.setItem('selectedMgaIdNew', mgaId);
  sessionStorage.setItem('selectedMgaIdDoc', 'false');
  sessionStorage.setItem('selectedMgaIdDocCheck', 'false');
  sessionStorage.setItem('selectedMgaIdDocDeactivated', 'false');
  sessionStorage.setItem('leadPage',this.leadPageNo);
  if (event.ctrlKey==1){
    localStorage.setItem('selectedMgaId', id);
    var win = window.open('/dashboard/mga-details/'+id, '_blank');
    var win = window.open('https://thzretail.com/TL-Broker-Self-Help-Portal/#/dashboard/mga-details/'+id, '_blank');
  // var win = window.open('https://mytl.travelance.ca/TL/#/dashboard/Training-details/'+data, '_blank');

    win.focus();
}else{
  localStorage.setItem('selectedMgaId', id)
  this.router.navigateByUrl('/dashboard/mga-details/'+id);
  
}
}

serachMga="";
loading=false;
searchPopup: boolean=false;
globalSearchCount: any=0;
globalSearchData=[];
searchMgaData(searchString){
  
  if(searchString == null || searchString == ""){
    this.getMgaUnderLeads();
  }
  if(searchString.length>1){
    this.searchPopup=true;
    this.user.searchMgaDashboardGlobal(searchString,this.leadPageNo,this.onSelectSizePage).pipe()
    .subscribe(
        data => {
          this.leads=[];
            // this.p=1;           
            // this.leads=[];            
            // this.leads=data.data;
            // this.total=data.data.length;
            // this.globalSearchData = data.data.leads;
            // this.globalSearchCount = data.data.total;
              this.leads=data.data.leads;
              this.total=data.data.total;
        },error=>{
          if (error.status == 404) {
            this.loading=false;
          }
          else {
           this.loading=false;
          }
            },()=>{});
  }else if(searchString.length<1){
    this.searchPopup=false;
  }
// this.user.searchMgaDashboard(this.serachMga).pipe()
// .subscribe(
//   data => {
//    console.log(data)
//   },error=>{
  
//       },()=>{});
}

csvOptions = {
  fieldSeparator: ',',
  quoteStrings: '"',
  decimalseparator: '.',
  showLabels: true,
  showTitle: true,
  title: 'Travalance Leads Detail',
  useBom: true,
  noDownload: false,
  headers: ["Agent Code", "AgentId", "Created At", "First Name", "Last Name", "Name","Work Phone", "Mobile", 
  "Lead Status Stage","Email", "Primary Address Province","Type"]
//   agentCode
// agentId
// createdAt
// firstName
// lastName
// name
// workPhone
// mobile
// leadStatusStage
// email
// primaryAddressProvince
// type
};

csvarray=[];
dtHolidays :any;
Export(){
  for(let j=0; j<this.selectedId.length;j++){
  for(let i=0; i<this.leads.length;i++){
   if(this.selectedId[j]==this.leads[i].id){
    //   (this.leadsList[i])  
    var obj={
      // "name":this.leadsList[i].name,
      // "mobile":this.leadsList[i].mobile,
      // "stageStatus":this.leadsList[i].stageStatus,
      // "workPhone":this.leadsList[i].workPhone,
      // "email":this.leadsList[i].leadEmail[0].email,
      // "type":this.leadsList[i].type,
      "agentCode":this.leads[i].agencyMag.agentCode, 
      "agentId":this.leads[i].agencyMag.agentId, 
      "createdAt":this.leads[i].createdAt,
      "firstName":this.leads[i].firstName,
      "lastName":this.leads[i].lastName,
      
      "name":this.leads[i].name,
      "workPhone":this.leads[i].workPhone,
      "mobile":this.leads[i].mobile,
      "leadStatusStage":this.leads[i].leadStatusStage,
      "email":this.leads[i].leadEmail[0].email,
      "primaryAddressProvince":this.leads[i].primaryAddressProvince,

      "type":this.leads[i].type,
    }
    this.csvarray.push(obj)
    // this.csvarray.push(this.leadsList[i].name+this.leadsList[i].mobile+this.leadsList[i].stageStatus+
    //   this.leadsList[i].langauges+this.leadsList[i].leadEmail[0].email+this.leadsList[i].type)
   }
  }
}
  // this.leadsList[index].isChecked
  //   (this.selectedId);
  this.dtHolidays=this.csvarray
  new  AngularCsv(this.dtHolidays, "Travelance Leads", this.csvOptions);
  this.selecteditem = false;
  //this.getLeadListData();
}

leadPageNo: any=0;
pageChnageDone(data){
  //debugger
 this.leadPageNo = data-1
 sessionStorage.setItem('leadPage',this.leadPageNo);
 this.searchMgaData(this.serachMga);
//  if(this.showActivatedTable==false){
//  if(this.onSelectSizePage == null || undefined){
//  this.user.getMGAPage(this.leadPageNo).pipe()
// .subscribe(
//    data => {
//     this.leads=[];
//     this.stage=[];
//      if(data.data.leads != null){
//       //  for(let i=0; i<data.data.leads.length;i++){
//         this.leads=data.data.leads;
//         this.total=data.data.total;
//         this.showLead = 30;
//       //  }
//       //
// sessionStorage.removeItem("allMgaData")
//       sessionStorage.setItem("allMgaData",JSON.stringify(data.data.leads))
//      }
//      if(data.data.stageWisePercentage != null){
//       this.stage=data.data.stageWisePercentage;
//      }
//    },error=>{
//        },()=>{});
//       }else{
//         this.user.getLeadBySize(this.leadPageNo,this.onSelectSizePage).pipe()
//         .subscribe(
//             data => {
//               this.leads=[];
//               this.stage=[];
//               this.checkvalue = this.onSelectSizePage
//               if(data.data.leads != null){
//                 // for(let i=0; i<data.data.leads.length;i++){
//                  this.leads=data.data.leads;
//                  this.total=data.data.total;
//                  this.showLead = this.onSelectSizePage;
//                 // }
//                 //
// sessionStorage.removeItem("allMgaData")
//                 sessionStorage.setItem("allMgaData",JSON.stringify(data.data.leads))
//               }
//               if(data.data.stageWisePercentage != null){
//                this.stage=data.data.stageWisePercentage;
//               }
//             },error=>{
//                 },()=>{});
//       }
//     }else{
//       if(this.moreInfoReqiredColumns == false){
//         if(this.onSelectSizePage == null || undefined){
//           this.user.getExpiryDocListingPage(this.isDeactivate,this.leadPageNo).pipe()
//          .subscribe(
//             data => {
//             //  this.stage=[];
//              if(data.data.licencesActions.length != 0){
//               this.leadsActivate=[];
//               for(let i=0; i<data.data.licencesActions.length;i++){
//                 this.leadsActivate.push(data.data.licencesActions[i]);  
//               }
//               //
// sessionStorage.removeItem("allMgaData")
//              sessionStorage.setItem("allMgaData",JSON.stringify(data.data.licencesActions))
//             }
//             this.totalActivate = data.data.total;
//             this.showLeadActivate=data.data.total;
//              if(data.data.licencesActions != null){
//               this.stage=data.data.licencesActions.lead.stagesViews;
//              }
//               // if(data.data.stageWisePercentage != null){
//               //  this.stage=data.data.stageWisePercentage;
//               // }
//             },error=>{
//                 },()=>{});
//                }else{
//                  this.user.getExpiryDocListingPageSiize(this.isDeactivate,this.leadPageNo,this.onSelectSizePage).pipe()
//                  .subscribe(
//                      data => {
//                       //  this.stage=[];
//                        this.checkvalue = this.onSelectSizePage
//                        if(data.data.licencesActions.length != 0){
//                         this.leadsActivate=[];
//                         for(let i=0; i<data.data.licencesActions.length;i++){
//                           this.leadsActivate.push(data.data.licencesActions[i]);  
//                         }
//                         //
// sessionStorage.removeItem("allMgaData")
//                        sessionStorage.setItem("allMgaData",JSON.stringify(data.data.licencesActions))
//                       }
//                       this.totalActivate = data.data.total;
//                       this.showLeadActivate=this.onSelectSizePage;
//                       //  if(data.data.licencesActions != null){
//                       //   this.stage=data.data.licencesActions.lead.stagesViews;
//                       //  }
//                      },error=>{
//                          },()=>{});
//                }
//       }else{
//         if(this.onSelectSizePage == null || undefined){
//           this.user.getExpiryDocListingPageMoreInfo(this.isDeactivate,this.leadPageNo).pipe()
//          .subscribe(
//             data => {
//             //  this.stage=[];
//              if(data.data.licencesActions.length != 0){
//               this.leadsActivate=[];
//               for(let i=0; i<data.data.licencesActions.length;i++){
//                 this.leadsActivate.push(data.data.licencesActions[i]);  
//               }
//               //
// sessionStorage.removeItem("allMgaData")
//              sessionStorage.setItem("allMgaData",JSON.stringify(data.data.licencesActions))
//             }
//             this.totalActivate = data.data.total;
//             this.showLeadActivate=data.data.total;
//              if(data.data.licencesActions != null){
//               this.stage=data.data.licencesActions.lead.stagesViews;
//              }
//               // if(data.data.stageWisePercentage != null){
//               //  this.stage=data.data.stageWisePercentage;
//               // }
//             },error=>{
//                 },()=>{});
//                }else{
//                  this.user.getExpiryDocListingPageSiizeMoreInfo(this.isDeactivate,this.leadPageNo,this.onSelectSizePage).pipe()
//                  .subscribe(
//                      data => {
//                       //  this.stage=[];
//                        this.checkvalue = this.onSelectSizePage
//                        if(data.data.licencesActions.length != 0){
//                         this.leadsActivate=[];
//                         for(let i=0; i<data.data.licencesActions.length;i++){
//                           this.leadsActivate.push(data.data.licencesActions[i]);  
//                         }
//                         //
// sessionStorage.removeItem("allMgaData")
//                        sessionStorage.setItem("allMgaData",JSON.stringify(data.data.licencesActions))
//                       }
//                       this.totalActivate = data.data.total;
//                       this.showLeadActivate=this.onSelectSizePage;
//                       //  if(data.data.licencesActions != null){
//                       //   this.stage=data.data.licencesActions.lead.stagesViews;
//                       //  }
//                      },error=>{
//                          },()=>{});
//                }
//       }
    
//     }
}

checkvalue: any;
onSelectSize(){
  if(this.showActivatedTable==false){
  if(this.onSelectSizePage != null &&  this.checkvalue != this.onSelectSizePage){
  this.p=0;
  this.user.getLeadBySize(this.p,this.onSelectSizePage).pipe()
.subscribe(
    data => {
      this.leads=[];
      this.stage=[];
      this.checkvalue = this.onSelectSizePage
      if(data.data.leads != null){
        // for(let i=0; i<data.data.leads.length;i++){
         this.leads=data.data.leads;
         this.total=data.data.total;
         this.showLead = this.onSelectSizePage;
         //
sessionStorage.removeItem("allMgaData")
         sessionStorage.setItem("allMgaData",JSON.stringify(data.data.leads))
        // }
      }
      if(data.data.stageWisePercentage != null){
       this.stage=data.data.stageWisePercentage;
      }
    },error=>{
        },()=>{});
}}else{
  this.user.getExpiryDocListingPageSiize(this.isDeactivate,this.leadPageNo,this.onSelectSizePage,this.MgaIddropdown).pipe()
           .subscribe(
               data => {
                //  this.stage=[];
                 this.checkvalue = this.onSelectSizePage
                 if(data.data.licencesActions.length != 0){
                  this.leadsActivate=[];
                  for(let i=0; i<data.data.licencesActions.length;i++){
                    this.leadsActivate.push(data.data.licencesActions[i]);  
                  }
                  //
sessionStorage.removeItem("allMgaData")
                 sessionStorage.setItem("allMgaData",JSON.stringify(data.data.licencesActions))
                }
                this.totalActivate = data.data.total;
                this.showLeadActivate=this.onSelectSizePage;;
                //  if(data.data.licencesActions != null){
                //   this.stage=data.data.licencesActions.lead.stagesViews;
                //  }
               },error=>{
                   },()=>{});
}

}

test(a,a1){
  ////
     
  (a);
this.sub = a1;
this.stageStatus=[];
this.selectedId=[];
this.showFilter=false;
this.clearSelection=false;
this.showdate=false;
this.selectAllCheckbox=false;
this.showDeactivationColumns=false;
this.showexpDocColumns=false;
this.showActivatedTable=false;
this.moreInfoReqiredColumns=false;
localStorage.setItem('filterStatus', a);
localStorage.setItem('filterStatusIndex', a1);
this.stageStatus.push(a);

if(this.fromDateTest != null || undefined){
this.fromDate=this.fromDateTest[0]
this.fromDate = this.DatePipe.transform(this.fromDate, 'yyyy-MM-dd');

this.toDate=this.fromDateTest[1]
this.toDate = this.DatePipe.transform( this.toDate, 'yyyy-MM-dd');
}
else{
this.fromDate=null;
this.toDate=null;
}

if(this.brokerType == "Select"|| this.brokerType== undefined){
this.brokerType1=this.brokerTypeTest

}
else{
this.brokerType1.push(this.brokerType);
}
if(this.commitionType ==  "Select" || this.commitionType== undefined){
this.commitionType1=this.commitionTypeTest

}
else{
this.commitionType1.push(this.commitionType);
}

this.user.filterLeadsPost(this.brokerType1,this.commitionType1,this.fromDate,this.stageStatus,this.toDate,this.MgaIddropdown)
.pipe()
.subscribe(

    data => {
      ////
      // this.leads=[];
      if(data.status== true){
        this.p=0 
        // Swal.fire('',data.message,'success')
        this.filterModal =false;   
        }
        if(data.status== false){
          Swal.fire('',data.message,'error')
          this.filterModal =false;
          this.leads=[];
          }
        if(data.data.leads.length != 0){
          this.leads=[];
          for(let i=0; i<data.data.leads.length;i++){
            this.leads.push(data.data.leads[i]);
            this.total = data.data.total;
            this.showLead=data.data.total;
     
          }
          //
sessionStorage.removeItem("allMgaData")
          sessionStorage.setItem("allMgaData",JSON.stringify(data.data.leads))
        }
        if(data.data.stageWisePercentage.length != 0){
          this.stage=[];
          for(let i=0; i<data.data.stageWisePercentage.length;i++){
            this.stage.push(data.data.stageWisePercentage[i]);
           // this.total = data.data.totalPages
          }
        }
      
    },error=>{
      if(error=="Bad Request"){
        Swal.fire("Bad Request please try again!")
        this.filterModal=false;
       // this.onClearFilterData();
     }
     else{
      Swal.fire("Something went wrong. Please check and try again!")
      this.filterModal=false;
     // this.onClearFilterData();
     
     }
        },()=>{});
  this.onClearFilterData();
}
  refreshPage(){
localStorage.removeItem('filterStatus');
localStorage.removeItem('filterStatusIndex');
sessionStorage.setItem('selectedMgaIdDoc', 'false');
sessionStorage.setItem('selectedMgaIdDocCheck', 'false');
sessionStorage.setItem('selectedMgaIdDocDeactivated', 'false');
  window.location.reload()
  }
  closeFilter(){
    this.stageShow=[];
  }
  showDeactivationColumns:boolean=false;
  showexpDocColumns:boolean=false;
  expdocumentsToggle(event){
  this.selectAllCheckbox=false;
  this.selectedId=[]
  this.serachMga1="";
  this.serachMga2="";
  this.serachMga="";
  this.serachMga3="";
  this.clearSelection=false;
    var checkFlag
    checkFlag = event.target.checked;
    if(checkFlag==true){
      this.showDeactivationColumns=false;
      this.moreInfoReqiredColumns=false;
      this.showexpDocColumns=true;
      this.showActivatedTable=true;
      this.isDeactivate=false;
      this.sub=null;
      this.getExpiredDocData();
    }
    else{
      this.showDeactivationColumns=false;
      this.showexpDocColumns=false;
      this.showActivatedTable=false;
      this.getMgaUnderLeads();
    }
  }
  deactivateddocumentsToggle(event){
    this.selectAllCheckbox=false;
    this.selectedId=[]
    this.serachMga1="";
    this.serachMga2="";
    this.serachMga="";
    this.serachMga3="";
    this.clearSelection=false;
    var checkFlag
    checkFlag = event.target.checked;
    if(checkFlag==true){
      this.showDeactivationColumns=true;
      this.moreInfoReqiredColumns=false;
      this.showexpDocColumns=false;
      this.isDeactivate=true;
      this.showActivatedTable=true;
      this.getExpiredDocData();
      this.sub=null;
    }
    else{
      this.showDeactivationColumns=false;
      this.showexpDocColumns=false;
      this.showActivatedTable=false;
      this.getMgaUnderLeads();
    }
  }
  minDate = new Date();
  isDeactivate:boolean=false;
  showActivatedTable: boolean=false;
  showLeadActivate: any=30;
  totalActivate: any;
  leadsActivate=[]
  getExpiredDocData() {
    this.user.getExpiryDocListing(this.isDeactivate,this.MgaIddropdown).pipe()
      .subscribe(
        data => {
          if(this.isDeactivate==false){
          this.leadsActivate=[];
          if(data.data.licencesActions.length != 0){        
            for(let i=0; i<data.data.licencesActions.length;i++){
              this.leadsActivate.push(data.data.licencesActions[i]);  
            }
            //
sessionStorage.removeItem("allMgaData")
           sessionStorage.setItem("allMgaData",JSON.stringify(data.data.licencesActions))
          }
        
          this.totalActivate = data.data.total;
          this.showLeadActivate=this.onSelectSizePage;;
        }
        else{
          this.leadsActivate=[];
          if(data.data.leads.length != 0){        
            for(let i=0; i<data.data.leads.length;i++){
              this.leadsActivate.push(data.data.leads[i]);  
            }
            
            //
sessionStorage.removeItem("allMgaData")
            sessionStorage.setItem("allMgaData",JSON.stringify(data.data.leads))
          }
        
          this.totalActivate = data.data.total;
          this.showLeadActivate=this.onSelectSizePage;;
        }
          // if(data.data.licencesActions != null){
          //   this.stage=data.data.licencesActions.lead.stagesViews;
          //  }
        
        },error=>{
        
            },()=>{});
  }

public paginationconfigNormal: PaginationInstance = {
    id: 'paginationNormal',
    itemsPerPage: 30,
    currentPage: 1
};
public paginationconfigActivate: PaginationInstance = {
  id: 'paginationActivate',
  itemsPerPage: 30,
  currentPage: 1
};

enofile:File=null;
enoSizeCheck: boolean=false;
FileDataList: any;
  fileenoName: any;
  fileExtensionENO: any;
  fileExtensionErrorENO: boolean;
  fileExtensionMessageENO: string;
  eoexpiryDate1: string;
  eoeffectiveDate1:string;
  fileeno: any;
  expiryDate: any;
  policyNumber: any;
  acceptedExtensions = ["jpg", "jpeg", "png", "pdf", "docx", "JPG", "JPEG", "PNG", "PDF", "DOCX"];

  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }

FileSelect(event) {
  // this.FileDataList=event.target.files;
  // this.fileenoName=this.FileDataList[0].name;
  this.enofile = event.target.files[0];
  if(this.enofile.size>4194304){
    this.enoSizeCheck=true;

    Swal.fire({
      icon: 'error',
      text: 'Please upload the filesize less than 4MB',
    })
  }else{
    this.enoSizeCheck=false;
    this.showemailErrorMsg=false;
  }

  if (event.target.files.length > 0) {
    this.FileDataList = event.target.files;
    this.fileenoName = this.FileDataList[0].name;

    this.fileExtensionENO = this.fileenoName.split('.').pop();
    if (this.isInArray(this.acceptedExtensions, this.fileExtensionENO)) {
      this.fileExtensionErrorENO = false;
      this.fileExtensionMessageENO = ""

      this.showemailErrorMsg = this.fileExtensionErrorENO
      this.fileenoName = this.FileDataList[0].name;
    } else {
      this.fileExtensionMessageENO = "Invalid file type, Please select file with allowed file types: .pdf, .png , .jpeg or .docx "
      this.fileExtensionErrorENO = true;
      this.showemailErrorMsg = this.fileExtensionErrorENO
      this.fileenoName = this.fileExtensionMessageENO

    }

  } else {
    this.showemailErrorMsg = false;
    this.fileenoName = ""
  }

}

showemailErrorMsg: boolean=false;
showdateErrorMsg: boolean=false;
showdateErrorMsg1: boolean=false;
showdateErrorMsgEffective: boolean=false;
msg: any;
msgfinal: any;
uploadEno() {
  var flag = true
  var errormsg = [];
  this.expiryDate = this.DatePipe.transform(this.eoexpiryDate1, 'yyyy-MM-dd');
  this.effectiveDate = this.DatePipe.transform(this.eoeffectiveDate1, 'yyyy-MM-dd');

 // if(this.fileId==null){
    if (!this.fileeno || this.fileeno.length <= 0 || this.showemailErrorMsg == true) { this.showemailErrorMsg = true; flag = false; errormsg.push('Choose File') }
 // }
  if (!this.expiryDate || this.expiryDate.length <= 0) { this.showdateErrorMsg = true; flag = false; errormsg.push('Enter Expiry Date') }
  if (!this.effectiveDate || this.effectiveDate.length <= 0) { this.showdateErrorMsgEffective = true; flag = false; errormsg.push('Enter Effective Date') }
  if (!this.policyNumber || this.policyNumber.length <= 0) { this.showdateErrorMsg1 = true; flag = false; errormsg.push('Enter E&O Policy Number') }
  if (this.enoSizeCheck==true) { this.showemailErrorMsg = true; flag = false; errormsg.push('Please upload the filesize less than 4MB') }

  
  if (flag == true) {

    this.FileUpload();
  }
  else {
    this.msg = errormsg.toString();
    this.msgfinal = this.msg.replace(",", '<br />');
    this.uploadExpEOPopup=false;
    Swal.fire("", "Please complete the following mandatory field(s):" + "<br>" + this.msgfinal, 'warning').then((res) => {
    this.uploadExpEOPopup=true;
    });

  }
}

productPhotofile: string | Blob;
documentId: any;
fileId: any;

FileUpload() {
  // for (var i = 0; i < this.FileDataList.length; i++) {
  //   this.productPhotofile = this.FileDataList[i];
    // if (this.productPhotofile != null) {
      const formData = new FormData();
      formData.append('file', this.productPhotofile);
      formData.append('expiryDate', this.expiryDate);
      formData.append('effectiveDate', this.effectiveDate);
      formData.append('policyNumber', this.policyNumber);
     // var data = sessionStorage.getItem('leadId')
      formData.append('leadId', this.docUploadLeadId);
      //  this.fileData=formData
      

      // if(this.documentId!=null && this.fileId!=null){
        formData.append('documentId', this.documentId)
        formData.append('fileId', this.fileId)
        // }

      this.uploadImages(formData)
 

  // }
}

async uploadImages(formData: FormData) {
      // this.loading = true;
  this.user.OverWriteEO(this.config.OverWriteEO, formData).subscribe((data: any) => {
    this.expdocumentsToggleAuto(true)
    this.expiryDate = "";
    this.fileeno = "";
    this.fileenoName = "";
    this.policyNumber = "";
    // this.finalDocs = data.data;
    // this.loading = false;
    this.documentId=null;
    this.uploadExpEOPopup=false;
    Swal.fire('', data.message, 'success');
  }, err => {
  });
}

fileExtensionLic: any;
fileExtensionErrorLic: boolean = false;
fileExtensionMessageLic: any;
FileDataListLic: any;
licfile: File=null;
fileenoNameLic: any;
FileSelectLic(event) {
  this.licfile = event.target.files[0];
  if(this.licfile.size>4194304){
    Swal.fire({
      icon: 'error',
      text: 'Please upload the filesize less than 4MB',
    })
  }

  if (event.target.files.length > 0) {
    this.FileDataListLic = event.target.files;
    this.fileenoNameLic = this.FileDataListLic[0].name;

    this.fileExtensionLic = this.fileenoNameLic.split('.').pop();
    if (this.isInArray(this.acceptedExtensions, this.fileExtensionLic)) {
      this.fileExtensionErrorLic = false;
      this.fileExtensionMessageLic = ""

      this.fileExtensionErrorMsg = this.fileExtensionErrorLic
      this.fileenoNameLic = this.FileDataListLic[0].name;
    } else {
      this.fileExtensionMessageLic = "Invalid file type, Please select file with allowed file types: .pdf, .png , .jpeg or .docx "
      this.fileExtensionErrorLic = true;
       this.fileExtensionErrorMsg = this.fileExtensionErrorLic
      this.fileenoNameLic = this.fileExtensionMessageLic

    }
    //this.uploadlicenseArray[i].showemailErrorMsgone=this.fileExtensionError;
    //this.fileenoNameLic=this.fileExtensionMessage;
  } else {
    this.fileExtensionErrorMsg = false;
    this.fileenoNameLic = ""
  }
}

fileExtensionErrorMsg: boolean=false;
showlicpErrorMsgone:  boolean=false;
showlicdErrorMsgone:  boolean=false;
showlictErrorMsgone:  boolean=false;
showlicnErrorMsgone:  boolean=false;
province: any;
licencesType: any;
licenseNumber: any;
filelicens: any;
expiryDateLic1: any;
effectiveDateLic1:any;

uploadlicensefile(expiryDateLic1,effectiveDateLic1,filelicens,licenseNumber,licencesType,province) {
  var flag = true
  var errormsg = [];
  expiryDateLic1 = this.DatePipe.transform(expiryDateLic1, 'yyyy-MM-dd');
  effectiveDateLic1=this.DatePipe.transform(effectiveDateLic1, 'yyyy-MM-dd');
 // if(this.fileIdlic==null){
    if (!filelicens || filelicens.length <= 0 || this.fileExtensionErrorMsg == true) { this.fileExtensionErrorMsg = true; flag = false; errormsg.push('Choose File') }
  //}
  if (!licenseNumber || licenseNumber.length <= 0) { this.showlicnErrorMsgone = true; flag = false; errormsg.push('Enter License Number') }
  if(!licencesType || licencesType.length <= 0){this.showlictErrorMsgone = true;  flag=false; errormsg.push('License Type')} 
  if (!expiryDateLic1 || expiryDateLic1.length <= 0) { this.showlicdErrorMsgone = true; flag = false; errormsg.push('Enter Expiry Date') }
  if (!effectiveDateLic1 || effectiveDateLic1.length <= 0) { this.showlicdErrorMsgone = true; flag = false; errormsg.push('Enter Effective Date') }
  if (!province || province.length <= 0) { this.showlicpErrorMsgone = true; flag = false; errormsg.push('Select Province') }

  if (flag == true) {
     this.FileUploadLic(expiryDateLic1,effectiveDateLic1,filelicens,licenseNumber,licencesType,province);
  }
  else {
    // this.uploadLicensePopup = !this.uploadLicensePopup;
    this.msg = errormsg.toString();
    this.msgfinal = this.msg.replace(",", '<br />');
  //  this.uploadnewLicensePopup=false;
    Swal.fire("", "Please complete the following mandatory field(s):" + "<br>" + this.msgfinal, 'warning')
  }
}

fileIdlic: any;
licenceId: any;
FileUploadLic(expiryDateLic1,effectiveDateLic1,filelicens,licenseNumber,licencesType,province) {
  if(this.FileDataListLic!=undefined){
  for (var i = 0; i < this.FileDataListLic.length; i++) {
    this.productPhotofile = this.FileDataListLic[i];
    if (this.productPhotofile != null) {
      const formData = new FormData();
      formData.append('file', this.productPhotofile);
      formData.append('expiryDate', expiryDateLic1);
      formData.append('effectiveDate', effectiveDateLic1);
      formData.append('leadId', this.docUploadLeadId);
      formData.append('licencesNumber', licenseNumber);
      formData.append('lincencesName', this.fileenoNameLic);

      formData.append('licencesType', licencesType);
      formData.append('province', province);
      if(this.fileIdlic!=null || this.licenceId!=null){
        formData.append('fileId', this.fileIdlic);
        formData.append('licenceId', this.licenceId);
      }
      this.uploadImagesLic(formData)
    }
  }
    }else{
      const formData = new FormData();
     // formData.append('file', this.productPhotofile);
      formData.append('expiryDate', expiryDateLic1);
      formData.append('effectiveDate', effectiveDateLic1);
      var data = sessionStorage.getItem('leadId');

      formData.append('leadId', this.docUploadLeadId);
      formData.append('licencesNumber', licenseNumber);
      formData.append('lincencesName', this.fileenoNameLic);

      formData.append('licencesType', licencesType);
      formData.append('province', province);
      if(this.fileIdlic!=null || this.licenceId!=null){
        formData.append('fileId', this.fileIdlic);
        formData.append('licenceId', this.licenceId);
      }
      this.uploadImagesLic(formData)
    }
}
async uploadImagesLic(formData: FormData) {
    this.user.submitFormService1(this.config.OverWriteLicences, formData).subscribe((data: any) => {
      this.expdocumentsToggleAuto(true)
      this.licenceId=null;
       this.fileIdlic=null;
      Swal.fire('', data.message, 'success');
      this.uploadnewLicensePopup=false;
      this.fileenoNameLic = "";
    }, err => {

    });
  }
  licencesTypes=[]
  getLeadDoc() {
  this.licencesTypes=[];       
   this.user.getdocuments().pipe()
      .subscribe(
        data => {
          this.licencesTypes = data.data.licencesTypes
        }, error => {         
        }, () => { });
  }
  provinceData=[];
  getDashboard() {
    this.user.getDashboardData().pipe()
      .subscribe(
        data => {
          this.provinceData=data.data.provinces;
          this.mgaName = data.data.leads.agencyMgaName;
          this.agencyMgaId=data.data.leads.agencyMgaId
          this.agencyId=data.data.leads.agencyId
          this.userId=data.data.leads.assignedTo.id
          this.leadType=data.data.leads.type
         }, error => {
        }, () => { });
  }
  docIdEno(data,id,docName,docNumber,expiryDate,docLeadId){
    this.docUploadLeadId=docLeadId;
    this.documentId=data;
    this.fileId=id;
    this.uploadExpEOPopup=true;
    this.policyNumber=docNumber
    // this.eoexpiryDate1=expiryDate
    this.fileenoName = ""
  }
  docUploadLeadId:any;
  docIdLicens(data,id,expiryDateLic1,licenseNumber,licencesType,province,docName,docLeadID){
    this.licenceId=data;
    this.fileIdlic=id;
    this.uploadnewLicensePopup=true;
    this.docUploadLeadId=docLeadID
    // this.expiryDateLic1=expiryDateLic1
    this.fileenoNameLic=""
    this.licenseNumber=licenseNumber
    this.licencesType=licencesType
    this.province=province
  }
  onDocd(id){
    //
    sessionStorage.setItem('selectedMgaId', id);
    sessionStorage.setItem('selectedMgaIdDoc', 'true');
    sessionStorage.setItem('selectedMgaIdDocDeactivated', 'false');
    sessionStorage.setItem('leadPage',this.leadPageNo);
  }
  expdocumentsToggleAuto(data){
    this.serachMga=null
    var checkFlag
    checkFlag = data;
    if(checkFlag==true){
      this.showDeactivationColumns=false;
      this.showexpDocColumns=true;
      this.moreInfoReqiredColumns=false;
      this.showActivatedTable=true;
      this.isDeactivate=false;
      this.sub=null;
      this.getExpiredDocData();
    }
    else{
      this.showDeactivationColumns=false;
      this.showexpDocColumns=false;
      this.showActivatedTable=false;
      this.getMgaUnderLeads();
    }
  }
  deactivateddocumentsToggleAuto(data){
    this.serachMga=null
    var checkFlag
    checkFlag = data;
    if(checkFlag==true){
      this.showDeactivationColumns=true;
      this.moreInfoReqiredColumns=false;
      this.showexpDocColumns=false;
      this.isDeactivate=true;
      this.showActivatedTable=true;
      this.getExpiredDocData();
      this.sub=null;
    }
    else{
      this.showDeactivationColumns=false;
      this.showexpDocColumns=false;
      this.showActivatedTable=false;
      this.getMgaUnderLeads();
    }
  }
  onClickMga1(event,id){
    ////debugger
    sessionStorage.setItem('selectedMgaId', id);
    sessionStorage.setItem('selectedMgaIdDoc', 'false');
    sessionStorage.setItem('selectedMgaIdDocCheck', 'true');
    sessionStorage.setItem('selectedMgaIdDocDeactivated', 'false');
    sessionStorage.setItem('leadPage',this.leadPageNo);
    if (event.ctrlKey==1){
      localStorage.setItem('selectedMgaId', id);
      var win = window.open('/dashboard/mga-details/'+id, '_blank');
      var win = window.open('https://thzretail.com/TL-Broker-Self-Help-Portal/#/dashboard/mga-details/'+id, '_blank');
    // var win = window.open('https://mytl.travelance.ca/TL/#/dashboard/Training-details/'+data, '_blank');
  
      win.focus();
  }else{
    localStorage.setItem('selectedMgaId', id)
    this.router.navigateByUrl('/dashboard/mga-details/'+id);
    
  }
  }
onClickMgaDeactivate(event,id){
  ////debugger
    sessionStorage.setItem('selectedMgaId', id);
    sessionStorage.setItem('selectedMgaIdDoc', 'false');
    sessionStorage.setItem('selectedMgaIdDocCheck', 'false');
    sessionStorage.setItem('selectedMgaIdDocDeactivated', 'true');
    sessionStorage.setItem('leadPage',this.leadPageNo);
    if (event.ctrlKey==1){
      localStorage.setItem('selectedMgaId', id);
      var win = window.open('/dashboard/mga-details/'+id, '_blank');
      var win = window.open('https://thzretail.com/TL-Broker-Self-Help-Portal/#/dashboard/mga-details/'+id, '_blank');
    // var win = window.open('https://mytl.travelance.ca/TL/#/dashboard/Training-details/'+data, '_blank');
  
      win.focus();
  }else{
    localStorage.setItem('selectedMgaId', id)
    this.router.navigateByUrl('/dashboard/mga-details/'+id);
    
  }
  }

sortOn:any="desc";
sortbyData:any="createdAt";
  onSort(data){
    this.sortOn="asc";
    this.sortbyData=data;

    this.user.getMGAPageBYSortAsc1(this.leadPageNo,this.onSelectSizePage,this.sortbyData).pipe()
    .subscribe(
        data => {
          this.leads=[];
          this.stage=[];
           if(data.data.leads != null){
            //  for(let i=0; i<data.data.leads.length;i++){
              this.leads=data.data.leads;
              this.total=data.data.total;
              this.showLead = 30;
              //
sessionStorage.removeItem("allMgaData")
              sessionStorage.setItem("allMgaData",JSON.stringify(data.data.leads))
            //  }
           }
           if(data.data.stageWisePercentage != null){
            this.stage=data.data.stageWisePercentage;
           }
         
        },error=>{
            },()=>{});
  }
  onSortdesc(data){
    this.sortOn="desc";
    this.sortbyData=data;
    this.user.getMGAPageBYSortDesc1(this.leadPageNo,this.onSelectSizePage,this.sortbyData).pipe()
    .subscribe(
        data => {
          this.leads=[];
          this.stage=[];
           if(data.data.leads != null){
            //  for(let i=0; i<data.data.leads.length;i++){
              this.leads=data.data.leads;
              this.total=data.data.total;
              this.showLead = 30;
              //
sessionStorage.removeItem("allMgaData")
              sessionStorage.setItem("allMgaData",JSON.stringify(data.data.leads))
            //  }
           }
           if(data.data.stageWisePercentage != null){
            this.stage=data.data.stageWisePercentage;
           }
         
        },error=>{
            },()=>{});
  }

  onSort1(data){
    this.sortOn="asc";
    this.sortbyData=data;

    this.user.getExpiryDocListingAsc1(this.isDeactivate,this.leadPageNo,this.onSelectSizePage,this.sortbyData,this.MgaIddropdown).pipe()
    .subscribe(
      data => {
        if(this.isDeactivate==false){
        this.leadsActivate=[];
        if(data.data.licencesActions.length != 0){        
          for(let i=0; i<data.data.licencesActions.length;i++){
            this.leadsActivate.push(data.data.licencesActions[i]);  
          }
          //
sessionStorage.removeItem("allMgaData")
           sessionStorage.setItem("allMgaData",JSON.stringify(data.data.licencesActions))
        }
      
        this.totalActivate = data.data.total;
        this.showLeadActivate=this.onSelectSizePage;
      }
      else{
        this.leadsActivate=[];
        if(data.data.leads.length != 0){        
          for(let i=0; i<data.data.leads.length;i++){
            this.leadsActivate.push(data.data.leads[i]);  
          }
          //
sessionStorage.removeItem("allMgaData")
            sessionStorage.setItem("allMgaData",JSON.stringify(data.data.leads))
        }
      
        this.totalActivate = data.data.total;
        this.showLeadActivate=this.onSelectSizePage;
      }
        // if(data.data.licencesActions != null){
        //   this.stage=data.data.licencesActions.lead.stagesViews;
        //  }
      
      },error=>{
      
          },()=>{});
  }
  onSortdesc1(data){
    this.sortOn="desc";
    this.sortbyData=data;
    this.user.getExpiryDocListingDesc1(this.isDeactivate,this.leadPageNo,this.onSelectSizePage,this.sortbyData,this.MgaIddropdown).pipe()
    .subscribe(
      data => {
        if(this.isDeactivate==false){
        this.leadsActivate=[];
        if(data.data.licencesActions.length != 0){        
          for(let i=0; i<data.data.licencesActions.length;i++){
            this.leadsActivate.push(data.data.licencesActions[i]);  
          }
          //
sessionStorage.removeItem("allMgaData")
           sessionStorage.setItem("allMgaData",JSON.stringify(data.data.licencesActions))
        }
      
        this.totalActivate = data.data.total;
        this.showLeadActivate=this.onSelectSizePage;
      }
      else{
        this.leadsActivate=[];
        if(data.data.leads.length != 0){        
          for(let i=0; i<data.data.leads.length;i++){
            this.leadsActivate.push(data.data.leads[i]);  
          }
          //
sessionStorage.removeItem("allMgaData")
            sessionStorage.setItem("allMgaData",JSON.stringify(data.data.leads))
        }
      
        this.totalActivate = data.data.total;
        this.showLeadActivate=this.onSelectSizePage;
      }
        // if(data.data.licencesActions != null){
        //   this.stage=data.data.licencesActions.lead.stagesViews;
        //  }
      
      },error=>{
      
          },()=>{});
        }
        onSort2(data){
          this.sortOn="asc";
          this.sortbyData=data;
      
          this.user.getExpiryDocListingAsc2(this.isDeactivate,this.leadPageNo,this.onSelectSizePage,this.sortbyData,this.MgaIddropdown).pipe()
          .subscribe(
            data => {
              if(this.isDeactivate==false){
              this.leadsActivate=[];
              if(data.data.licencesActions.length != 0){        
                for(let i=0; i<data.data.licencesActions.length;i++){
                  this.leadsActivate.push(data.data.licencesActions[i]);  
                }
                //
sessionStorage.removeItem("allMgaData")
           sessionStorage.setItem("allMgaData",JSON.stringify(data.data.licencesActions))
              }
            
              this.totalActivate = data.data.total;
              this.showLeadActivate=data.data.total;
            }
            else{
              this.leadsActivate=[];
              if(data.data.leads.length != 0){        
                for(let i=0; i<data.data.leads.length;i++){
                  this.leadsActivate.push(data.data.leads[i]);  
                }
                //
sessionStorage.removeItem("allMgaData")
            sessionStorage.setItem("allMgaData",JSON.stringify(data.data.leads))
              }
            
              this.totalActivate = data.data.total;
              this.showLeadActivate=data.data.total;
            }
              // if(data.data.licencesActions != null){
              //   this.stage=data.data.licencesActions.lead.stagesViews;
              //  }
            
            },error=>{
            
                },()=>{});
        }
        onSortdesc2(data){
          this.sortOn="desc";
          this.sortbyData=data;
          this.user.getExpiryDocListingDesc2(this.isDeactivate,this.leadPageNo,this.onSelectSizePage,this.sortbyData,this.MgaIddropdown).pipe()
          .subscribe(
            data => {
              if(this.isDeactivate==false){
              this.leadsActivate=[];
              if(data.data.licencesActions.length != 0){        
                for(let i=0; i<data.data.licencesActions.length;i++){
                  this.leadsActivate.push(data.data.licencesActions[i]);  
                }
                //
sessionStorage.removeItem("allMgaData")
           sessionStorage.setItem("allMgaData",JSON.stringify(data.data.licencesActions))
              }
            
              this.totalActivate = data.data.total;
              this.showLeadActivate=data.data.total;
            }
            else{
              this.leadsActivate=[];
              if(data.data.leads.length != 0){        
                for(let i=0; i<data.data.leads.length;i++){
                  this.leadsActivate.push(data.data.leads[i]);  
                }
                //
sessionStorage.removeItem("allMgaData")
            sessionStorage.setItem("allMgaData",JSON.stringify(data.data.leads))
              }
            
              this.totalActivate = data.data.total;
              this.showLeadActivate=data.data.total;
            }
              // if(data.data.licencesActions != null){
              //   this.stage=data.data.licencesActions.lead.stagesViews;
              //  }
            
            },error=>{
            
                },()=>{});
              }
  serachMga1="";
  serachMga2="";
  serachMga3="";
  searchMgaDataDocuments(searchString){
    if(searchString.length>1){
      this.user.searchMgaDashboardDoc(this.isDeactivate,searchString).pipe()
      .subscribe(
            data => {
                  // if(data.status==true){
                    this.p=1;
                    if(this.isDeactivate==false){
                      this.leadsActivate=[];
                      if(data.data.licencesActions.length != 0){        
                        for(let i=0; i<data.data.licencesActions.length;i++){
                          this.leadsActivate.push(data.data.licencesActions[i]);  
                        }
                        //
sessionStorage.removeItem("allMgaData")
           sessionStorage.setItem("allMgaData",JSON.stringify(data.data.licencesActions))
                      }
                    
                      this.totalActivate = data.data.total;
                      this.showLeadActivate=data.data.total;
                    }
                    else{
                      this.leadsActivate=[];
                      if(data.data.leads.length != 0){        
                        for(let i=0; i<data.data.leads.length;i++){
                          this.leadsActivate.push(data.data.leads[i]);  
                        }
                        //
sessionStorage.removeItem("allMgaData")
            sessionStorage.setItem("allMgaData",JSON.stringify(data.data.leads))
                      }
                    
                      this.totalActivate = data.data.total;
                      this.showLeadActivate=data.data.total;
                    }
                  //console.log(data)
                },error=>{
                  if (error.status == 404) {
                    this.loading=false;
                  }
                  else {
                  //  this.getLeadListData();
                   this.loading=false;
                  }
                    },()=>{});
          }else if(searchString.length<1){
             this.getExpiredDocData();
          }
        // this.user.searchMgaDashboard(this.serachMga).pipe()
        // .subscribe(
        //   data => {
        //    console.log(data)
        //   },error=>{
          
        //       },()=>{});
        }
  MoreInfoReqData=[];
  moreInfoRequiredApi(){
    this.user.getMoreInfoReqData(this.isDeactivate,this.MgaIddropdown).pipe()
    .subscribe(
      data => {
        if(this.isDeactivate==false){
          this.leadsActivate=[];
          if(data.data.licencesActions.length != 0){        
            for(let i=0; i<data.data.licencesActions.length;i++){
              this.leadsActivate.push(data.data.licencesActions[i]);  
            }
            //
sessionStorage.removeItem("allMgaData")
           sessionStorage.setItem("allMgaData",JSON.stringify(data.data.licencesActions))
          }
        
          this.totalActivate = data.data.total;
          this.showLeadActivate=data.data.total;
        }
        else{
          this.leadsActivate=[];
          if(data.data.leads.length != 0){        
            for(let i=0; i<data.data.leads.length;i++){
              this.leadsActivate.push(data.data.leads[i]);  
            }
            //
sessionStorage.removeItem("allMgaData")
            sessionStorage.setItem("allMgaData",JSON.stringify(data.data.leads))
          }
        
          this.totalActivate = data.data.total;
          this.showLeadActivate=data.data.total;
        }
      }, error => {         
      }, () => { });
  }
  moreInfoReqiredColumns: boolean=false;
  moreInfoReqiredToggle(event){
    this.selectedId=[];
    this.selectAllCheckbox=false;
    this.clearSelection=false;
    var checkFlag
    checkFlag = event.target.checked; 
    if(checkFlag==true){
      this.moreInfoReqiredColumns=true;
      this.showDeactivationColumns=false;
      this.showexpDocColumns=false;
      this.isDeactivate=false;
      this.showActivatedTable=true;
      this.moreInfoRequiredApi();
      this.sub=null;
    }
    else{
      this.moreInfoReqiredColumns=false;
      this.showexpDocColumns=false;
      this.showActivatedTable=false;
      this.getMgaUnderLeads();
    }
  }
  searchMgaDataMoreInfoReq(searchString){
    if(searchString.length>1){
      this.user.searchMgaMoreInfo(this.isDeactivate,searchString).pipe()
      .subscribe(
            data => {
                  // if(data.status==true){
                    this.p=1;
                    if(this.isDeactivate==false){
                      this.leadsActivate=[];
                      if(data.data.licencesActions.length != 0){        
                        for(let i=0; i<data.data.licencesActions.length;i++){
                          this.leadsActivate.push(data.data.licencesActions[i]);  
                        }
                        //
sessionStorage.removeItem("allMgaData")
           sessionStorage.setItem("allMgaData",JSON.stringify(data.data.licencesActions))
                      }
                    
                      this.totalActivate = data.data.total;
                      this.showLeadActivate=data.data.total;
                    }
                    else{
                      this.leadsActivate=[];
                      if(data.data.leads.length != 0){        
                        for(let i=0; i<data.data.leads.length;i++){
                          this.leadsActivate.push(data.data.leads[i]);  
                        }
                        //
sessionStorage.removeItem("allMgaData")
            sessionStorage.setItem("allMgaData",JSON.stringify(data.data.leads))
                      }
                    
                      this.totalActivate = data.data.total;
                      this.showLeadActivate=data.data.total;
                    }
                  //console.log(data)
                },error=>{
                  if (error.status == 404) {
                    this.loading=false;
                  }
                  else {
                  //  this.getLeadListData();
                   this.loading=false;
                  }
                    },()=>{});
          }else if(searchString.length<1){
             this.moreInfoRequiredApi();
          }
        }
  downloadFileLink:any;
  exportIDString:any;
  exportLead(){
    if(this.exportAllLeads==true){
      this.exportIDString="All"
    }else{
      this.exportIDString=this.selectedId.toString();
    }
    this.user.exportLeads(this.exportIDString).pipe()
        .subscribe(
          data => {
            this.downloadFileLink = data.data
            saveAs(this.downloadFileLink, "Leads_"+this.currentDateabc+".xlsx");
          }, error => {
    
    
          }, () => { });
  }
  clearSelection:boolean=false;
      selectallRecords:boolean=true;
      exportAllLeads:boolean=false;
      deactivateAllLeads:boolean=false;
      selectAllRecords(){
        for(let i=0; i<this.leads.length;i++){
          this.leads[i].isChecked=true;
          }
        for(let i=0; i<this.leadsActivate.length;i++){
          this.leadsActivate[i].isChecked=true;
        }
        this.clearSelection=true;
        this.selectallRecords=false;
        this.selectAllCheckbox=true;
        this.subChecked=true;
        this.exportAllLeads=true;
        this.deactivateAllLeads=true;
        
      }
      clearAllRecords(){
        for(let i=0; i<this.leads.length;i++){
          this.leads[i].isChecked=false;
        }
        for(let i=0; i<this.leadsActivate.length;i++){
          this.leadsActivate[i].isChecked=false;
        }
        this.selectedId=[];
        this.clearSelection=false;
        this.selectallRecords=true;
        this.selectAllCheckbox=false;
        this.subChecked=false;
        this.selecteditem = false;
        this.exportAllLeads=false;   
        this.deactivateAllLeads=false;
      }
      isResetOpen:boolean=false;
      resetPayment() {
        this.isResetOpen = !this.isResetOpen;
      }
      deActivateBroker(item){
        //debugger
        this.leadId = item?.id
        Swal.fire({
          text: "By clicking the ‘Deactivate’ button below, you understand that the broker won’t be able to sell products through MyTL and would require to be reactivated to be able to sell.",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          // cancelButtonColor: '#d33',
          confirmButtonText: 'Yes'
        }).then((result) => {
          if (result.isConfirmed) {
            this.user.OADeactivateLeads(this.leadId).pipe()
               .subscribe(
                data => {
                  if(data.status==true){
                  Swal.fire("", data.message,'success');
                  this.isResetOpen =false;
                  this.MgaIddropdown = sessionStorage.getItem('MgaIddropdown');
                    var filterState = localStorage.getItem('filterStatus');
                    var filterIndex = localStorage.getItem('filterStatusIndex');
                    var DocumentsTag = sessionStorage.getItem('selectedMgaIdDoc');
                    var DocumentsTagCheck = sessionStorage.getItem('selectedMgaIdDocCheck');
                    var DocumentsTagDeactivated = sessionStorage.getItem('selectedMgaIdDocDeactivated');
                    if (filterState != undefined) {
                      this.test(filterState, filterIndex)
                    } else {
                      // this.getLeadListData();
                      this.getMgaUnderLeads();
                    }
                    if (DocumentsTag == 'true' || DocumentsTagCheck == 'true') {
                      this.expdocumentsToggleAuto(true)
                    }
                    if (DocumentsTagDeactivated == 'true') {
                      this.deactivateddocumentsToggleAuto(true);
                    }
                  }else{
                    data.success==false;
                    Swal.fire("", data.message,'error');
                    this.isResetOpen =false;
                  }
                }, error => {
  
                }, () => { });
          }
        })
      }
      deActivateLead(){
        //debugger
        Swal.fire({
          text: "By clicking the ‘Deactivate’ button below, you understand that the broker won’t be able to sell products through MyTL and would require to be reactivated to be able to sell.",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          // cancelButtonColor: '#d33',
          confirmButtonText: 'Yes'
        }).then((result) => {
          if (result.isConfirmed) {
            this.user.OADeactivateLeadsMultiple(this.selectedDeactivatedId).pipe()
               .subscribe(
                data => {
                  if (data.status == true) {
                    Swal.fire("", data.message, 'success');
                    this.isResetOpen = false;
                    this.MgaIddropdown = sessionStorage.getItem('MgaIddropdown');
                    var filterState = localStorage.getItem('filterStatus');
                    var filterIndex = localStorage.getItem('filterStatusIndex');
                    var DocumentsTag = sessionStorage.getItem('selectedMgaIdDoc');
                    var DocumentsTagCheck = sessionStorage.getItem('selectedMgaIdDocCheck');
                    var DocumentsTagDeactivated = sessionStorage.getItem('selectedMgaIdDocDeactivated');
                    if (filterState != undefined) {
                      this.test(filterState, filterIndex)
                    } else {
                      // this.getLeadListData();
                      this.getMgaUnderLeads();
                    }
                    if (DocumentsTag == 'true' || DocumentsTagCheck == 'true') {
                      this.expdocumentsToggleAuto(true)
                    }
                    if (DocumentsTagDeactivated == 'true') {
                      this.deactivateddocumentsToggleAuto(true);
                    }
                  this.selectedDeactivatedId=[]
                  this.selectAllCheckbox=false;
                  this.selectallRecords=false;
                  this.isDeactivateButton=false;
                  }else{
                    this.selectedDeactivatedId=[]
                    this.selectAllCheckbox=false;
                    this.selectallRecords=false;
                    data.success==false;
                    Swal.fire("", data.message,'error');
                    this.isResetOpen =false;
                    this.isDeactivateButton=false;
                  }
                }, error => {
  
                }, () => { });
          }
        })

    }
    getLeadAgentsCodes(){
      this.user.getLeadAgentsCodes(this.leadsId).pipe()
      .subscribe(
        data => {
        this.agentcodedata=[];  
        for(let i=0;i<data.data.agentCodes.length;i++){      
          if (data?.data?.agentCodes[i]?.agentUserId?.includes("_") || data?.data?.agentCodes[i]?.agentUserId?.includes("RL1")) {
            // If agentUserId contains underscore, do something
        } else {
            // If agentUserId does not contain underscore, push agentCodes[i] into agentcodedata
            this.agentcodedata.push(data.data.agentCodes[i]);
        }
        }
        }, error => {   
      
        }, () => { });
      }
      toggleadd(a,a1,agentCode,agentId,status) {
        //debugger
        sessionStorage.setItem('agentIdSalesPortal',agentCode);
        sessionStorage.setItem('agentIdS',agentId);
        sessionStorage.setItem('agencyCodeSalesPortal',a);
        if(status=="Active" || status=="Primary"){
          sessionStorage.setItem('agentIdActive','true');
        }
        else{
          sessionStorage.setItem('agentIdActive','false');
        }
        this.subAgent = a1;
         this.agentcodedata1=[]
         this.drop = false
        for(let i=0;i<this.agentcodedata.length;i++){
          if(this.agentcodedata[i].agentCode == a && this.agentcodedata[i].id==agentCode){
            this.agentcodedata1.push(this.agentcodedata[i]);
          }
        }
      this.drop = !this.drop;
       if (this.drop) {
         this.drop = true;
         this.noti = false;
       }
       else {
         this.drop = false;
       }
     }
     close1(){
      this.drop = !this.drop;
      // window.location.reload()
     }
     goToGetReliable(){
      var win = window.open(this.url, '_blank');
      win.focus();
    }
     showAddAgent: boolean = false;
  onClickAddAgent() {
    debugger
    this.leadEmailAddress=[]
    this.addtearms1(100)
    this.showAddAgent = true;
  }
  firstName: any;
  lastName: any;
  email: any;
  workPhone: any;
  address: any;
  leadEmailAddressErrMsg: boolean = false;
  onClickSaveAndSendAgent() {
    this.checkPhone()
      var flag=true
  var errormsg=[];

 if(this.leadEmailAddress[0].error3!=""
  || this.leadEmailAddress[0].error5!=""
  || this.leadEmailAddress[0].error6!=""
  )
  {
    flag=false;
    this.leadEmailAddressErrMsg = true;
  }
 if(!this.firstName || this.firstName.length <= 0){flag=false; errormsg.push("'First Name'")} 

if(!this.lastName || this.lastName.length <= 0){ flag=false; errormsg.push("'Last Name'")}
if(this.leadEmailAddress[0].email==""  || this.leadEmailAddress.length <= 0){flag=false; this.leadEmailAddressErrMsg=true; errormsg.push("'Email Address'")}
if(this.primaryAddressPostalCode){
    if(this.primaryAddressPostalCode.length>5){
      this.primaryAddressPostalCode=this.primaryAddressPostalCode.replace(/\s/g, "")
      // this.primaryAddressPostalCode=this.primaryAddressPostalCode.replace(/.{3}$/,' $&');
    }
  }
  if(this.primaryAddressPostalCode !==null &&  this.primaryAddressPostalCode !==undefined &&  this.primaryAddressPostalCode !==""){
  if(!this.primaryAddressPostalCode || (this.primaryAddressPostalCode.length <=0 || this.primaryAddressPostalCode.length <6)){flag=false;}
  else{
    this.primaryAddressPostalCode=this.primaryAddressPostalCode.replace(/.{3}$/,' $&');
  }
  }
  var re = /^[A-Z]\d[A-Z][ -]?\d[A-Z]\d$/i;
  if(this.primaryAddressPostalCode !==null &&  this.primaryAddressPostalCode !==undefined &&  this.primaryAddressPostalCode !==""){
if (!re.test(this.primaryAddressPostalCode)) {
  {flag=false; errormsg.push("'Postal Code'")}

}
}
else{
  flag=false; errormsg.push("'Postal code'")
}
if(this.primaryAddressCity!==undefined && this.primaryAddressCity!=="" ){
this.primaryAddressCity=this.primaryAddressCity.replace(/(^[,\s]+)|([,\s]+$)/g, '');
}
if(this.primaryCompleteAddress!==undefined && this.primaryCompleteAddress!=="" ){
  this.primaryCompleteAddress=this.primaryCompleteAddress.replace(/(^[,\s]+)|([,\s]+$)/g, '');
}
if(this.primaryAddressCity!==undefined && this.primaryAddressCity!==""){
  this.primaryAddressCity=this.primaryAddressCity.trim() 
}
if(this.primaryCompleteAddress !==undefined && this.primaryCompleteAddress!==""){
  this.primaryCompleteAddress=this.primaryCompleteAddress.trim()
}
if(this.primaryAddressCity !==undefined && this.primaryAddressCity!==""){
  this.primaryAddressCity=titleCase1(this.primaryAddressCity) 
}
if(this.primaryCompleteAddress !==undefined && this.primaryCompleteAddress!==""){
  this.primaryCompleteAddress=titleCase1(this.primaryCompleteAddress) 
}
function capitalizeFirstLetter(string) {
  return string[0].toUpperCase() + string.slice(1).toLowerCase();
}
      function titleCase(string) {
        return string.split(" ").map(x => capitalizeFirstLetter(x)).join(" ");
    }
      function titleCase1(string) {
        return string.split(',').map(x => capitalizeFirstLetter(x)).join(",");
    }
        if(this.primaryAddressCity !==undefined && this.primaryAddressCity!==""){
      this.primaryAddressCity=titleCase(this.primaryAddressCity) 
  }
    if(this.primaryCompleteAddress !==undefined && this.primaryCompleteAddress!==""){
      this.primaryCompleteAddress=titleCase(this.primaryCompleteAddress) 
  }
      function makeUpperCaseAfterCommas(str) {
      return str.replace(/,\s*([a-z])/g, function(d,e) { return ", "+e.toUpperCase() });
  }
  if(this.primaryAddressCity !==undefined && this.primaryAddressCity!==""){
    this.primaryAddressCity=makeUpperCaseAfterCommas(this.primaryAddressCity)
}
  if(this.primaryCompleteAddress !==undefined && this.primaryCompleteAddress!==""){
    this.primaryCompleteAddress=makeUpperCaseAfterCommas(this.primaryCompleteAddress) 
}
   if(this.workPhone != null && this.workPhone != undefined){
  if(this.error1!==null || this.error9!==null){
      flag=false; errormsg.push("'Business Phone'")
  }
}else{
  flag=false; errormsg.push("'Business Phone'")
}
  if(!this.primaryCompleteAddress || this.primaryCompleteAddress.length <= 0){  flag=false; errormsg.push('Primary Complete Address')} 
  
  if(!this.primaryAddressCity || this.primaryAddressCity.length <= 0){ flag=false; errormsg.push('Primary Address City')} 
  if(!this.primaryAddressProvince || this.primaryAddressProvince.length <= 0){flag=false; errormsg.push('Primary Address Province')} 
  if (!this.purchaseEmailConfirm ||(this.leadEmailAddress[0].email !== this.purchaseEmailConfirm)) { flag=false;errormsg.push("'Confirm Email Address'") }
  if(flag==true){
    this.user.addLeads(this.salutation,this.workPhoneExt, this.countTraining,this.firstName,this.middleName,this.primaryCompleteAddress,this.lastName,this.primaryAddressCountry,this.primaryAddressCity,this.primaryAddressProvince,'Agreement Sent',
    this.primaryAddressPostalCode,this.userId,this.alternativeCompleteAddress,this.type,this.alternativeAddressCountry,this.languages, this.alternativeAddressCity,this.leadSource,this.ciprnumber,this.productSelling,
    this.positionTitle,this.alternativeAddressProvince,this.agencyMgaId,this.alternativeAddressPostalCode,this.workPhone,this.mobileNumber,this.leadMailCompanian,this.emailAddress,this.leadSubSource,this.website,this.tags,this.leadEmailAddress,this.allProvicesList,
    this.FirstSignUpDate,this.consentstat,
    
  this.proofConsent,
  this.adminOnly,
  this.ConsentDate,

  this.CountCalls,
  this.CountTasks,
  this.dncStatusval,
  this.agentNurture,
  this.ResidentLicenseExpiryDate,
  this.ResidentProvince,
  this.UserID,
  this.Password,
  this.TravelLink,
  this.RepresentingCompanies,
  this.OtherPhone,
  this.Fax,
  this.HomePhone,
  this.checkFlagCASLdata,
  this.Title,
  this.AgencyAdditionalOffices,
  this.residentAddressBeans,
  this.agencyCode,
this.companyName,
this.leadSourceOther,
this.leadTraining,
this.licencesType,
this.MyTravelLinkRequest,this.jumpStart,
this.specialBonus,
this.wfgCode,
this.isCompanySignup,this.commissionsTo,this.secondaryEmailAddress,this.agencyId).pipe()
      .subscribe(
        data => {
          if (data.status == true) {
            Swal.fire('', data.message, 'success');
            this.showAddAgent=false
            this.closeAgentPopup();
            this.MgaIddropdown = sessionStorage.getItem('MgaIddropdown');
                    var filterState = localStorage.getItem('filterStatus');
                    var filterIndex = localStorage.getItem('filterStatusIndex');
                    var DocumentsTag = sessionStorage.getItem('selectedMgaIdDoc');
                    var DocumentsTagCheck = sessionStorage.getItem('selectedMgaIdDocCheck');
                    var DocumentsTagDeactivated = sessionStorage.getItem('selectedMgaIdDocDeactivated');
                    if (filterState != undefined) {
                      this.test(filterState, filterIndex)
                    } else {
                      // this.getLeadListData();
                      this.getMgaUnderLeads();
                    }
                    if (DocumentsTag == 'true' || DocumentsTagCheck == 'true') {
                      this.expdocumentsToggleAuto(true)
                    }
                    if (DocumentsTagDeactivated == 'true') {
                      this.deactivateddocumentsToggleAuto(true);
                    }
          } else {
            Swal.fire('Add lead failed please try again!')
          }
        }, error => {
        }, () => { });
      }
      else {
            this.msg = errormsg.toString();
      this.msgfinal = this.msg.replace(/,/g, '<br />');  // Use regex to replace all commas
      Swal.fire({
        title: "",
        html: "Please complete the following mandatory field(s):<br>" + this.msgfinal,  // Use 'html' instead of plain text
        icon: 'warning'
      });
          }
  }
  addtearms1(i) {
    if (i == 100) {
      var obj = {};
      obj["email"] = "";
      obj["id"] = "0";
      obj["isinvalid"] = false;
      obj["isOptedOut"] = false;
      obj["isPrimary"] = true;

      this.leadEmailAddress.push(obj);

    }
  }
  checkPatternWork(pho){
  this.error9=null
  var re = /^[0-9-+() ]*$/;
if (!re.test(pho.toLowerCase())) {
this.error9="Please Enter a Valid  Work Phone"
this.error1=null
}
  }
  error1: string;
  error9: string;
   checkPhone(){
      if(this.workPhone != null){
 this.user.checkphoneNumber(this.workPhone).pipe()
  .subscribe(
      data => { 
       if(data.data=="false")
       {
this.error1="Please Enter a Valid  Work Phone";
this.error9=null
       }
       else{
         this.error1=null;
       }
      },error=>{
          if(error.status == 400 || error.status==417){
              this.error=error.error.data;
           }
           else{
             this.error="Something went wrong";
           }
          },()=>{});
        }
       else{
         this.error1=null;
       }
    }
  checkEmail(index, row) {
    row.error6 = "";
    row.error5 = "";
    row.error3 = "";
    if (row.isPrimary == true) {
      this.user.checkEmail(this.leadEmailAddress[index].email).pipe()
        .subscribe(
          data => {
            if (data.data == "false") {
            }
            else {
              row.error3 = "This email address is already partnered with Travelance.Please ask the user to log in to  <a href='https://mytl.travelance.ca' target='_blank' rel='noopener noreferrer'> mytl.travelance.ca</a> or contact <a href='mailto:join@travelance.ca' target='_blank' rel='noopener noreferrer'>join@travelance.ca</a> for assistance.";
              this.leadEmailAddressErrMsg = true
            }
          }, error => {
            if (error.status == 400 || error.status == 417) {
              this.error = error.error.data;

            }
            else {

              this.error = "Something went wrong";
            }
            //  }
          }, () => { });
    }
  }

  emailCheck(email, row) {
    row.error5 = ""
    row.error3 = ""
    row.error6 = ""
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!re.test(email.toLowerCase())) {
      row.error5 = "Please enter valid Email"
      this.leadEmailAddressErrMsg = true
      //alert("please enter valid email");

    }
  }
  leadEmailAddressErrMsgred() { if (!this.leadEmailAddress) { this.leadEmailAddressErrMsg = true } else { this.leadEmailAddressErrMsg = false } }
  callAddressApiCall() {
    this.showAddressResults1 = true;
    this.user.getAddressCanada1(this.primaryCompleteAddress).subscribe((data: any) => {
      this.getPrimaryAddress = data.suggestions;
    }, error => {
      {
      }
    }, () => { });
  }
  getSelectedAddress2: any[]=[];
    onClickSearchResultprimary(item){
              debugger
              this.showAddressResults1=false;
              this.user.getAddressCanadaSelected(item.action.id).subscribe((data:any) =>{
                this.ErrorMsgten=false
                this.getSelectedAddress2 = data.features;
                this.primaryAddressCity=this.getSelectedAddress2[0]?.properties?.place;
                this.primaryAddressPostalCode=this.getSelectedAddress2[0]?.properties?.postcode;
                this.primaryAddressProvince=this.getSelectedAddress2[0]?.properties?.region_code;
                this.primaryCompleteAddress=this.getSelectedAddress2[0]?.properties?.address_line1;
               },error=>{{
               }},()=>{})
              
            }
  ip(primaryAddressPostalCode) {

    this.primaryAddressPostalCode = this.primaryAddressPostalCode.toUpperCase()
    if (primaryAddressPostalCode.length > 5) {
      this.primaryAddressPostalCode = this.primaryAddressPostalCode.replace(/\s/g, "")
      this.primaryAddressPostalCode = this.primaryAddressPostalCode.replace(/.{3}$/, ' $&');
    }
    var re = /^[A-Z]\d[A-Z][ -]?\d[A-Z]\d$/i;
if (!re.test(this.primaryAddressPostalCode)) {
this.ErrorMsgten=true

}
else{
  this.ErrorMsgten=false
}
  }
  closeAgentPopup(){
    this.firstName=""
this.lastName=""
this.leadEmailAddress=[]
this.workPhone=null
this.primaryCompleteAddress=""
this.primaryAddressCity=""
this.primaryAddressProvince=""
this.primaryAddressPostalCode=""
this.purchaseConfirmEmailFlag=false
this.ErrorMsgten=false
this.confirmEmailMatch=false
this.error9=null
this.error1=null
this.purchaseEmailConfirm=""
  }
    confirmEmailMatch: boolean = false;
  purchaseEmailConfirm: any = "";
  purchasePhone2: any;
  checkConfirmEmail() {

    if (this.leadEmailAddress[0].email && this.purchaseEmailConfirm) {
      if (this.leadEmailAddress[0].email == this.purchaseEmailConfirm) {
        this.confirmEmailMatch = false;
        this.purchaseConfirmEmailFlag = false;
      } else {
        this.confirmEmailMatch = true;
        this.purchaseConfirmEmailFlag = false;
      }
    }

  }
  onConfirmEmailClick(){
    this.purchaseConfirmEmailFlag=false;  
    }
}
